(function () {
    'use strict';

    angular
        .module('app.campaignAdvertiserManagePage')
        .controller('campaignAdvertiserManagePageCtrl', ['$scope', '$rootScope', 'campaignAdvertiserManagePageService', '$modal', 'localStorageService', '$state', '$location', 'TRACK_EVENTS',
            function ($scope, $rootScope, campaignAdvertiserManagePageService, $modal, localStorageService, $state, $location, TRACK_EVENTS) {
                var me = this;
                me.checked = false;

                $scope.haveData = false;
                var currentUser = $rootScope.currentUser;
                $scope.selectedAdvertiser = currentUser.company != null ? currentUser.company.id : null;

                if ($rootScope.sideMenuSelections.advertiserId != null || $rootScope.sideMenuSelections.advertiserId !== undefined) {
                    $scope.selectedAdvertiser = $rootScope.sideMenuSelections.advertiserId;
                }

                $scope.getCampaignsForCompany = function (loader) {
                    campaignAdvertiserManagePageService.getCampaignsForCompany($scope.selectedAdvertiser, loader)
                        .then(function (response) {
                            if (response.data == null) {
                                $scope.haveData = false;
                            } else {
                                $scope.campaigns = response.data;
                                $scope.haveData = response.data.length > 0;
                                angular.forEach($scope.campaigns, function (item, index) {
                                    item.is_expand = false;
                                    item.index = index;
                                })
                                checkPreviousExpanded();
                            }
                        }).catch(function (errorResponse) {
                            $rootScope.handleRequestError(errorResponse, $scope);
                        });
                }

                $scope.getCampaignsForCompany(true);

                $scope.$on('reload_campaignList', function () {
                    if ($rootScope.sideMenuSelections.advertiserId != null || $rootScope.sideMenuSelections.advertiserId !== undefined) {
                        $scope.selectedAdvertiser = $rootScope.sideMenuSelections.advertiserId;
                    }
                    $scope.getCampaignsForCompany(true);
                });

                $scope.expandCampaignInfluencerInfo = function (campaign) {
                    // Mixpanel tracking campaign clicking
                    if (!campaign.is_expand) {
                        analytics.track(
                            TRACK_EVENTS.CLICK_ON_CAMPAIGN.EVT_NAME,
                            {
                                "item": TRACK_EVENTS.CLICK_ON_CAMPAIGN.ITEM_NAME,
                                "target_type": TRACK_EVENTS.CLICK_ON_CAMPAIGN.ITEM_NAME,
                                "target_name": campaign.campaign_name,
                                "target_id": campaign.campaign_id
                            }
                        );
                    }
                    $rootScope.expandedCampaign = campaign;
                    angular.forEach($scope.campaigns, function (item) {
                        if (item.campaign_id !== campaign.campaign_id) {
                            item.is_expand = false;
                        } else {
                            if (!campaign.influencer_list) {
                                campaignAdvertiserManagePageService.getInfluencersForCampaign(campaign.campaign_id, true)
                                    .then(function (response) {
                                        campaign.influencer_list = response.data || [];

                                        if (campaign.influencer_list.length > 0 && campaign.campaign_type == 'campaign-creation') {
                                            $rootScope.$broadcast('showLoader', { controller: 'myHttpInterceptor' });
                                            generateCampaignInfluencerKPIPieChart(campaign);
                                        } else {
                                            $rootScope.$broadcast('hideLoader', { controller: 'myHttpInterceptor' });
                                            campaign.is_expand = !campaign.is_expand;
                                        }
                                    }).catch((function (errorResponse) {
                                        $rootScope.handleRequestError(errorResponse, $scope);
                                    }));
                            } else {
                                campaign.is_expand = !campaign.is_expand;
                            }
                        }
                    })
                }

                var checkPreviousExpanded = function () {
                    var keepGoing = true;
                    if ($rootScope.expandedCampaign && $rootScope.expandedCampaign.is_expand && !me.checked) {
                        angular.forEach($scope.campaigns, function (item) {
                            if (keepGoing && item.campaign_id === $rootScope.expandedCampaign.campaign_id) {
                                $scope.expandCampaignInfluencerInfo(item);
                                me.checked = true;
                                keepGoing = false;
                            }
                        })
                    };
                }

                $scope.goToMeasurePage = function (campaign_id) {
                    $rootScope.$broadcast('select_campaign', { campaign_id : campaign_id });

                    $state.transitionTo('home.measure', {
                        reload: false,
                        inherit: true,
                        notify: true
                    });
                }

                $scope.gotoInfluencerCampaignActivity = function (row) {
                    $rootScope.previousPageOfActivityPage = $location.absUrl();
                    $state.transitionTo('home.campaignActivityPage', { campaign_influencer_id: row.campaign_influencer_id }, {
                        reload: false,
                        inherit: false,
                        notify: true
                    });
                }

                $scope.deleteCampaign = function (campaign) {
                    var deleteCampaignConfirmModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/campaign/campaignAdvertiserManagePage/modals/confirmDeleteCampaign.html?app_v=deployDate',
                        controller: 'DeleteCampaignCtrl'
                    });

                    $scope.campaign_id_delete = campaign.campaign_id;
                    $scope.campaign_name_delete = campaign.campaign_name;
                    $scope.deleteCampaignConfirmModalInstance = deleteCampaignConfirmModalInstance;
                }

                $scope.saveInfluencerToCampaign = function (campaign) {
                    var addInfluencerToCampaignModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/campaign/campaignAdvertiserManagePage/modals/addInfluencer/advertiserAddInfluencers.html?app_v=deployDate',
                        controller: 'campaignAdvertiserManagePageAddInfluencersCtrl'
                    });

                    $scope.campaign_id_add_influencer = campaign.campaign_id;
                    $scope.addInfluencerToCampaignModalInstance = addInfluencerToCampaignModalInstance;

                    addInfluencerToCampaignModalInstance.result.then(function () {
                        $scope.getCampaignsForCompany(true);
                    });
                }

                $scope.addCampaign = function () {
                    var addCampaignModalInstance = $modal.open({
                        scope: $scope,
                        backdrop: 'static', // prevent closing when click outside
                        templateUrl: 'app/campaign/campaignAdvertiserManagePage/campaignForm/campaignForm.html?app_v=deployDate',
                        controller: 'CampaignFormCtrl',
                        windowClass: 'modal-xlg'
                    });

                    $scope.editMode = false;
                    $scope.addCampaignModalInstance = addCampaignModalInstance;
                }

                $scope.editCampaign = function (campaign) {
                    var editCampaignModalInstance = $modal.open({
                        scope: $scope,
                        backdrop: 'static', // prevent closing when click outside
                        templateUrl: 'app/campaign/campaignAdvertiserManagePage/campaignForm/campaignForm.html?app_v=deployDate',
                        controller: 'CampaignFormCtrl',
                        windowClass: 'modal-xlg'
                    });

                    $scope.editMode = true;
                    $scope.editingCampaignId = campaign.campaign_id;
                    $scope.editCampaignModalInstance = editCampaignModalInstance;
                }

                var pieChartConfig = {
                    options: {
                        chart: {
                            type: 'pie',
                            zoomType: 'x',
                            marginTop: 16
                        },
                        tooltip: {
                            enabled: false
                        },
                        plotOptions: {
                            pie: {
                                allowPointSelect: false,
                                cursor: 'pointer',
                                dataLabels: {
                                    enabled: false
                                },
                                showInLegend: false
                            }
                        },

                        credits: {
                            enabled: false
                        }
                    },
                    series: [{
                        size: '80%',
                        innerSize: '90%'
                    }],
                    title: {
                        text: '',
                        style: {
                            fontSize: '16px',
                            color: '#4B5567',
                            fontFamily: 'ProximaNovaRegular'
                        }
                    },
                    xAxis: {
                        type: 'datetime',
                        title: {
                            text: 'Date'
                        }
                    },
                    noData: 'Pending Data...',
                    loading: true
                };

                function generateCampaignInfluencerKPIPieChart(campaign) {
                    var tempConfig = angular.copy(pieChartConfig);
                    tempConfig.options.chart = {
                        type: 'pie',
                        zoomType: 'x',
                        backgroundColor: null,
                        marginBottom: 0,
                        marginLeft: 0,
                        marginRight: 0,
                        marginTop: 0,
                        width: 40,
                        height: 40,
                        style: {
                            "overflow": "visible"
                        }
                    };

                    tempConfig.options.tooltip = {
                        useHTML: true,
                        followPointer: false,
                        hideDelay: 0,
                        backgroundColor: "#333b48",
                        headerFormat: "",
                        borderRadius: 24,
                        borderWidth: 0,
                        shadow: false,
                        shape: "callout",
                        style: {
                            "color": "#FFFFFF",
                            "padding": "6"
                        },
                        positioner: function (boxWidth, boxHeight, point) {
                            var chart = this.chart,
                                plotLeft = chart.plotLeft,
                                plotTop = chart.plotTop,
                                plotWidth = chart.plotWidth,
                                plotHeight = chart.plotHeight;
                            return { x: chart.plotLeft + chart.plotWidth / 2 - boxWidth / 2, y: chart.plotTop - boxHeight / 2 - 20 };
                        },
                        pointFormatter: function () {
                            if (this.name == 'Other') {
                                if (this.series.points[0].name == 'Impact') {
                                    return this.series.points[0].name + ': ' + Highcharts.numberFormat(this.series.points[0].value, 0, 0, ',') + '%';
                                } else {
                                    return this.series.points[0].name + ': ' + Highcharts.numberFormat(this.series.points[0].value, 0, 0, ',');
                                }
                            } else {
                                if (this.name == 'Impact') {
                                    return this.name + ': ' + Highcharts.numberFormat(this.value, 0, 0, ',') + '%';
                                } else {
                                    return this.name + ': ' + Highcharts.numberFormat(this.value, 0, 0, ',');
                                }
                            }
                        }
                    };
                    tempConfig.series[0] = {
                        size: '31',
                        innerSize: '25',
                        states: {
                            hover: {
                                halo: {
                                    size: 1
                                }
                            }
                        }
                    };

                    var item = {};
                    _.forEach(campaign.influencer_list, function (influencer) {
                        item = influencer;
                        // reach
                        if (item.campaign_influencer_reach != null) {
                            item.campaign_influencer_reach.pieChartConfig = angular.copy(tempConfig);
                            item.campaign_influencer_reach.pieChartConfig.series[0].name = item.campaign_influencer_reach.name;
                            item.campaign_influencer_reach.pieChartConfig.series[0].data = [{ name: 'Reach', color: '#FF6C9D', y: item.campaign_influencer_reach.percent, value: item.campaign_influencer_reach.value },
                            { name: 'Other', color: '#EEEEEE', y: (1 - item.campaign_influencer_reach.percent), value: item.campaign_influencer_reach.value }];
                        }

                        // engagement
                        if (item.campaign_influencer_engagement != null) {
                            item.campaign_influencer_engagement.pieChartConfig = angular.copy(tempConfig);
                            item.campaign_influencer_engagement.pieChartConfig.series[0].name = item.campaign_influencer_engagement.name;
                            item.campaign_influencer_engagement.pieChartConfig.series[0].data = [{ name: 'Engagement', color: '#00D6EF', y: item.campaign_influencer_engagement.percent, value: item.campaign_influencer_engagement.value },
                            { name: 'Other', color: '#EEEEEE', y: (1 - item.campaign_influencer_engagement.percent), value: item.campaign_influencer_engagement.value }];
                        }

                        // impact
                        if (item.campaign_influencer_impact != null) {
                            item.campaign_influencer_impact.pieChartConfig = angular.copy(tempConfig);
                            item.campaign_influencer_impact.pieChartConfig.series[0].name = item.campaign_influencer_impact.name;
                            item.campaign_influencer_impact.pieChartConfig.series[0].data = [{ name: 'Impact', color: '#4A5568', y: item.campaign_influencer_impact.percent, value: item.campaign_influencer_impact.value },
                            { name: 'Other', color: '#EEEEEE', y: (1 - item.campaign_influencer_impact.percent), value: item.campaign_influencer_impact.value }];
                        }

                    });

                    campaign.is_expand = !campaign.is_expand;
                    campaign.showChart = true;

                    setTimeout(function () {
                        $rootScope.$broadcast('hideLoader', { controller: 'myHttpInterceptor' });
                    }.bind(campaign), 1000);
                }
            }
        ])

        .controller('DeleteCampaignCtrl', ['$scope', '$modal', 'campaignAdvertiserManagePageService', '$http', '$modalInstance', '$rootScope',
            function ($scope, $modal, campaignAdvertiserManagePageService, $http, $modalInstance, $rootScope) {
                $scope.confirmDeleteCampaign = function () {
                    campaignAdvertiserManagePageService.deleteCampaign($scope.campaign_id_delete, true)
                        .then(function (responseDeleteCampaign) {
                            $scope.closeModal();
                            $rootScope.$broadcast('reload_campaignList', { advertiserId : $scope.selectedAdvertiser });
                        }, function (responseDeleteCampaign) {
                            $rootScope.handleRequestError(responseDeleteCampaign, $scope);
                        });
                }

                $scope.closeModal = function () {
                    $modalInstance.close();
                }
            }
        ])

})();